// Derive a display excerpt from an existing summary; never call a provider or persist data.
// Bound by words/length rather than sentence punctuation: initials and company suffixes
// (for example "Arthur J. Gallagher & Co.") must not consume the whole excerpt.
export function extractDescription(summaryText) {
  if (typeof summaryText !== 'string' || !summaryText.trim()) return '';
  const match = summaryText.match(/(?:^|\n)[ \t]*(?:#{1,6}[ \t]*)?(?:\*\*|__)?(?:1[.)][ \t]*)?COMPANY INFO\b[ \t]*([\s\S]*?)(?:\n[ \t]*(?:#{1,6}[ \t]*)?(?:\*\*|__)?(?:[2-9][.)][ \t]*)?(?:RECOMMENDATION|SIGNIFICANT EVENTS)\b|$)/i);
  if (!match) return '';

  const body = match[1]
    .replace(/[#*`>]/g, '')
    .replace(/^[_:\s]+/, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (body.length <= 400) return body;

  const prefix = body.slice(0, 399);
  const lastSpace = prefix.lastIndexOf(' ');
  const excerpt = (lastSpace > 0 ? prefix.slice(0, lastSpace) : prefix).trimEnd();
  return `${excerpt}…`;
}

// Repair only the known generated-name truncation at display time. Provenance is
// mandatory; a manual or unknown-source value is never replaced.
export function getExecutiveDescription({ description, companyName, aiSummaryText }) {
  const value = description?.value;
  const normalized = (text) => typeof text === 'string' ? text.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  if (description?.source !== 'aiSummary' || !normalized(companyName)
      || normalized(value) !== normalized(companyName)) return value;
  return extractDescription(aiSummaryText) || value;
}
